import React from 'react';
import Link from './Link';

export default function({ label, className }) {
    return (
        <Link to='pages/exhibit-application' className={'button ' + className}>{label}</Link>        
    );
}


// WEBPACK FOOTER //
// ./src/components/BecomeExhibitorButton.js